import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import { ClientAiAssistantProvider } from '../components/ClientAiAssistantDrawer';
import RequireAuth from '../components/RequireAuth';
import { ClientAccountProvider, useClientAccount } from '../account/AccountContext';
import AccountSelectionPage from '../pages/AccountSelectionPage';
import AuthCallbackPage from '../pages/AuthCallbackPage';
import ApprovalsPage from '../pages/ApprovalsPage';
import DashboardPage from '../pages/DashboardPage';
import EvidencePackagesPage from '../pages/EvidencePackagesPage';
import ClientEvidenceWorkspacePage from '../pages/ClientEvidenceWorkspacePage';
import PackageDetailPage from '../pages/PackageDetailPage';
import ActionsRequiredPage from '../pages/ActionsRequiredPage';
import LoginPage from '../pages/LoginPage';
import AccountDisabledPage from '../pages/AccountDisabledPage';
import ReportsPage from '../pages/ReportsPage';
import UsersPage from '../pages/UsersPage';

function AccountPortal() {
  const { accountId } = useParams();
  const { selectedAccount, loading, error } = useClientAccount();

  if (loading) {
    return <main className="portal-loading-page"><div className="notice">Loading AWS environment…</div></main>;
  }
  if (error) {
    return <Navigate to="/select-account" replace />;
  }
  if (!selectedAccount || selectedAccount.accountId !== accountId) {
    return <Navigate to="/select-account" replace />;
  }

  return (
    <ClientAiAssistantProvider key={selectedAccount.accountId}>
      <Layout key={selectedAccount.accountId}>
        <Routes>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="approvals" element={<ApprovalsPage />} />
          <Route path="approvals/:jobId" element={<ApprovalsPage />} />
          <Route path="evidence-packages" element={<EvidencePackagesPage />} />
          <Route path="evidence-workspace" element={<ClientEvidenceWorkspacePage />} />
          <Route path="evidence-workspace/:packageId" element={<ClientEvidenceWorkspacePage />} />
          <Route path="evidence-packages/:packageId" element={<PackageDetailPage />} />
          <Route path="actions-required" element={<ActionsRequiredPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="*" element={<Navigate to="dashboard" replace />} />
        </Routes>
      </Layout>
    </ClientAiAssistantProvider>
  );
}

function ProtectedPortal() {
  return (
    <RequireAuth>
      <ClientAccountProvider>
        <Routes>
          <Route path="/select-account" element={<AccountSelectionPage />} />
          <Route path="/accounts/:accountId/*" element={<AccountPortal />} />
          <Route path="*" element={<Navigate to="/select-account" replace />} />
        </Routes>
      </ClientAccountProvider>
    </RequireAuth>
  );
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/account-disabled" element={<AccountDisabledPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/*" element={<ProtectedPortal />} />
    </Routes>
  );
}
